<template>
  <div class="text-size-buttons__wrapper">
    <a-button
      :button-style="$options.consts.BUTTON_STYLE.NO_STYLE"
      class="text-size__button"
      @click="openCloseSizeButtons"
    >
      <a-icon
        :icon="buttonIcon"
        :width="16"
        :height="16"
        class="text-size__icon"
      />
      {{ buttonText }}
    </a-button>

    <div v-if="isExpanded" class="text-size__size-buttons-container">
      <div
        v-for="(button, index) in buttonSizes"
        :key="index"
        class="text-size__size-buttons"
      >
        <a-button
          :button-style="$options.consts.BUTTON_STYLE.NO_STYLE"
          :class="dynamicStyleActiveButton(button.size)"
          class="text-size__button"
          @click="onChangeTextSize(button)"
        >
          {{ button.text }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BUTTON_STYLE } from 'shared/AButton/index.vue'
import AIcon, { ICON } from 'shared/AIcon'
import { ACCESSIBILITY_TEXT_SIZE_STORAGE_KEY, ARTICLE_TEXT_SIZE } from './enums'

export default {
  name: 'ATextSizeButton',
  components: { AIcon },
  consts: {
    BUTTON_STYLE
  },
  data() {
    return {
      ICON,
      isExpanded: false,
      activeButtonTextSize: '',
      buttonSizes: [
        {
          text: 'Normal',
          size: ARTICLE_TEXT_SIZE.NORMAL
        },
        {
          text: 'Large',
          size: ARTICLE_TEXT_SIZE.LARGE
        },
        {
          text: 'Largest',
          size: ARTICLE_TEXT_SIZE.LARGEST
        }
      ]
    }
  },
  computed: {
    buttonText() {
      return !this.isExpanded ? 'Text Size' : ''
    },
    buttonIcon() {
      return !this.isExpanded ? ICON.TEXT_SIZE : ICON.CROSS
    }
  },
  methods: {
    openCloseSizeButtons() {
      this.isExpanded = !this.isExpanded
    },
    onChangeTextSize(selectedButton) {
      this.activeButtonTextSize = selectedButton.size

      window.localStorage.setItem(
        ACCESSIBILITY_TEXT_SIZE_STORAGE_KEY,
        selectedButton.size
      )

      this.$emit('select', selectedButton.size)
    },
    dynamicStyleActiveButton(textSize) {
      if (!textSize) return {}

      return {
        active: textSize === this.activeButtonTextSize
      }
    },
    setTextSize() {
      const localStorageKey = window.localStorage.getItem(
        ACCESSIBILITY_TEXT_SIZE_STORAGE_KEY
      )

      if (!localStorageKey) {
        this.activeButtonTextSize = ARTICLE_TEXT_SIZE.NORMAL
        window.localStorage.setItem(
          ACCESSIBILITY_TEXT_SIZE_STORAGE_KEY,
          ARTICLE_TEXT_SIZE.NORMAL
        )
      } else {
        this.activeButtonTextSize = localStorageKey
      }
    }
  },
  mounted() {
    this.setTextSize()
  }
}
</script>

<style lang="scss" scoped>
.text-size-buttons__wrapper {
  display: flex;
  padding: 0px 10px 0 12px;
  border-radius: 100px;
  border: 1px solid $c--gray-light;

  /deep/ .a-button__general-style {
    width: fit-content;

    .a-button__slot-wrapper {
      display: flex;
      flex-direction: row;
      padding: 0;
    }
  }
}

.text-size__button {
  padding: 6px;

  @include textSecondaryButton;
}

.text-size__icon {
  margin-right: 4px;
}

.text-size__size-buttons-container {
  display: flex;
}

.text-size__size-buttons {
  display: flex;

  .active {
    color: $c--main;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
